import React, { useState } from 'react';
import clanLogo from "../../../assets/images/clan_connect_logo.png"
import './order-confirmed.scss'
import { useEffect } from 'react';

interface Props {
  userType: string;
  planName: string;
  campaignPlanId: string;
  campaignId: string;
  modalContent?: string;
  children?: any;
  isMobileConfirmed?: boolean;
}

const OrderConfirmedTemplate: React.FC<Props> = ({
  userType,
  planName,
  campaignPlanId,
  campaignId,
  modalContent,
  children,
  isMobileConfirmed
}) => {

  const [open_app, set_open_app] = useState(false);


  function openAppWithFallback() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  const universalLink = 'https://app.clanconnect.ai/welcome/profile';
  const androidScheme = 'clanconnect:///welcome/profile';

  // const fallbackUrl = isIOS
  //   ? 'https://apps.apple.com/app/idYOUR_APP_ID'
  //   : 'https://play.google.com/store/apps/details?id=ai.clanconnect.app';

  if (isIOS) {
    // window.location.href = universalLink;
    set_open_app(true);
  } else if (isAndroid) {
    set_open_app(false); 
    let countdown = 5;
    const countdownElement = document.getElementById('countdown');
    if (countdownElement) {
      countdownElement.textContent = countdown.toString();
    }

    const countdownInterval = setInterval(() => {
      countdown--;
      if (countdownElement) {
        countdownElement.textContent = countdown.toString();
      }

      if (countdown === 0) {
        clearInterval(countdownInterval);
        window.location.href = androidScheme;
      }
    }, 1000);
  } else {
    // window.location.href = fallbackUrl;
  }
  }


  // enum to set support mail
  const SupportMail = {
    BRAND_SUPPORT_MAIL: 'brand.support@clanconnect.ai',
    INFLUENCER_SUPPORT_MAIL: 'influencer.support@clanconnect.ai'
  }
  // to redirect to home page after count down ends
  // if (userType === "Influencer") {
  //   if (!isMobileConfirmed) {
  //     // const appUrl = `clanconnect:///welcome/profile`; // Deep link into the app
  //     // const fallbackUrl = isIOS()
  //     //   ? 'https://apps.apple.com/app/idYOUR_APP_ID' // <-- Replace with your actual App Store ID
  //     //   : 'https://play.google.com/store/apps/details?id=ai.clanconnect.app';

  //     // // Try to open the app
  //     // window.location.href = appUrl;

  //     // // Fallback after a short delay
  //     // setTimeout(() => {
  //     //   window.location.href = appUrl;
  //     //   // window.location.href = fallbackUrl;
  //     // }, 2000);

  //     openAppWithFallback();
  //   } else {
  //     let countdown = 5;
  //     const countdownInterval = setInterval(() => {
  //       countdown--;
  //       const countdownElement = document.getElementById('countdown');
  //       if (countdownElement) countdownElement.textContent = countdown.toString();
  //       if (countdown === 0) {
  //         clearInterval(countdownInterval);
  //         window.location.href = "/influencer/dashboard";
  //       }
  //     }, 1000);
  //   }
  // }

  useEffect(() => {
  if (userType === "Influencer") {
    if (isMobileConfirmed) {
      openAppWithFallback();
    } else {
      let countdown = 5;
      const countdownElement = document.getElementById('countdown');
      if (countdownElement) {
        countdownElement.textContent = countdown.toString();
      }

      const countdownInterval = setInterval(() => {
        countdown--;
        const countdownElement = document.getElementById('countdown');
        if (countdownElement) {
          countdownElement.textContent = countdown.toString();
        }

        if (countdown === 0) {
          clearInterval(countdownInterval);
          window.location.href = "/influencer/dashboard";
        }
      }, 1000);

      return () => clearInterval(countdownInterval);
    }
  }
}, [userType, isMobileConfirmed]);

  return (
    <div className="main-content-sec padd-content-top full-width">
      <div className="confirmed-info-container">
        {(userType === "Influencer" && !open_app) && (
          <div className="redirecting">
            <span>Redirecting in </span>
            <span id="countdown">{5}</span>
            <span> seconds...</span>
          </div>
        )}
        <div className="d-flex justify-content-center align-items-center mt-3 mb-4">
          <img
            alt="Clan Connect"
            height="93"
            src={clanLogo}
            style={{ display: 'inline-block', verticalAlign: 'middle' }}
            width="221"
          />
        </div>
        <strong className="d-block pb-1 text-center" style={{ fontSize: '22px', color: 'green' }}>
          <span className="bi bi-check-lg fs-20"></span>
          <span>Thank you for subscribing to ClanConnect</span>
        </strong>
        {children}
        <p>
          Feel free to email us at{' '}
          {['Brand', 'Agency'].includes(userType) ? (
            <a href={SupportMail.BRAND_SUPPORT_MAIL}>{SupportMail.BRAND_SUPPORT_MAIL}</a>
          ) : (
            <a href={SupportMail.INFLUENCER_SUPPORT_MAIL}>{SupportMail.INFLUENCER_SUPPORT_MAIL}</a>
          )}{' '}
          with any questions or feedback you may have.
        </p>
        <br />
        <p style={{ color: '#0097d0', fontSize: '25px', marginBottom: '10px' }}>Thank You</p>
        <p style={{ fontSize: '18px', margin: '0px', display: 'inline-block' }}>Team ClanConnect</p>
        {
          ['New Campaign', 'New Paid Campaign', 'New Barter Campaign', 'Republish Campaign', 'Upgrade Barter Proposal Limit'].includes(planName)
          ?
            ['Upgrade Barter Proposal Limit'].includes(planName)
            ?
              <a href={`/brand/campaigns/proposals?planID=${campaignPlanId}&campaignID=${campaignId}`} className="btn btn-outline-primary d-flex justify-content-center">View Proposals</a>
            :
              <a href='/brand/plans' className="btn btn-outline-primary d-flex justify-content-center">View Campaign</a>
          : 
            isMobileConfirmed ? 
            // For mobile confirmed, redirect to mobile app
             !open_app && 
            <span className="btn btn-outline-primary d-flex justify-content-center"
                onClick={() => openAppWithFallback()}
            >OK</span>
              :
            // For web confirmed, redirect to dashboard
            <a href={['Brand', 'Agency'].includes(userType) ? '/brand/dashboard' : '/influencer/dashboard'} className="btn btn-outline-primary d-flex justify-content-center">OK</a>
          }
          {open_app && (
            <p
              style={{
                fontSize: '16px',
                color: '#333',
                backgroundColor: '#f8f9fa',
                padding: '12px 16px',
                borderLeft: '4px solid #007bff',
                borderRadius: '4px',
                margin: '16px 0',
                fontFamily: 'Open Sans, sans-serif',
              }}
            >
              To continue, please open the app.
            </p>
          )}
      </div>
    </div>
  );
};

export default OrderConfirmedTemplate;